import * as THREE from "three";
import * as TWEEN from "@tweenjs/tween.js";
import { RoundedBoxGeometry } from "three/examples/jsm/geometries/RoundedBoxGeometry.js";
import GlobalColorSingleton from "./GlobalColor";
import Letter3D from "./3DLetter";
import AudioEffects from "./AudioEffects";
export default class Letter extends THREE.Group {
  constructor(all_textures) {
    super();
    // this.scene = scene;
    const DEFAULT_COLOR = GlobalColorSingleton.color;
    this.all_textures = all_textures;

    this.geometry = new RoundedBoxGeometry(20, 20, 5, 6, 2);
    this.geometry.translate(0, 10, 0);
    let defaultMaterial = new THREE.MeshPhongMaterial({
      color: DEFAULT_COLOR,
      shininess: 100,
      specular: 0x222222,
    });
    let cubeMaterialArray = [];
    // order to add materials: x+,x-,y+,y-,z+,z-
    cubeMaterialArray.push(defaultMaterial);
    cubeMaterialArray.push(defaultMaterial);
    cubeMaterialArray.push(defaultMaterial);
    cubeMaterialArray.push(defaultMaterial);
    cubeMaterialArray.push(
      new THREE.MeshPhongMaterial({
        color: 0xffffff,
        shininess: 100,
        specular: 0x222222,
        // side: THREE.DoubleSide,
        // map: all_textures[0][0],
      })
    );
    cubeMaterialArray.push(defaultMaterial);
    this.cube = new THREE.Mesh(this.geometry, cubeMaterialArray);

    this.setupDefaultRotations();

    // rotate the cube 90 degrees
    // this._offset = -10;
    // if (Math.random() > 0.75) {
    //   this.rotation.x = -Math.PI / 2;
    //   this._offset = -8;
    //   this.rotation.z = Math.PI / 12 - Math.random() * (Math.PI / 6);
    // } else if (Math.random() > 0.6) {
    //   this._fall = true;
    //   this._offset2 = -8;
    // }

    this.cube.castShadow = true;
    this.cube.receiveShadow = true;
    this.position.y = -31;

    this.add(this.cube);

    this._type = "letter_block";
    this.isInGame = false;
  }

  stayVertical() {
    this._offset = -10;
    this._fall = false;
    this.rotation.x = 0;
    this._initialRotation = 0;
    this.rotation.z = 0;
  }

  setupDefaultRotations(isGameClue = false) {
    this._offset = -10;
    this._fall = false;
    this.rotation.x = 0;
    this._initialRotation = 0;
    this.rotation.z = 0;
    if (Math.random() > 0.85) {
      // flat on the ground
      this.rotation.x = -Math.PI / 2;
      this._initialRotation = -Math.PI / 2;
      this._offset = -8;
      this.rotation.z = Math.PI / 12 - Math.random() * (Math.PI / 6);
    } else if (Math.random() > 0.7) {
      // will fall on the ground
      this._fall = true;
      this._offset2 = -8;
      // fake, but we know it's gonna fall
      this._initialRotation = -Math.PI / 2;
    }

    if (isGameClue) {
      this._offset = -10;
      this._fall = false;
      this.rotation.x = 0;
      this._initialRotation = 0;
      this.rotation.z = 0;
    }
  }

  cleanUpGroup() {
    this.children.forEach((child) => {
      if (child instanceof THREE.Mesh) {
        this.remove(child);
      }
    });
  }

  set(_letter, isGameClue = false) {
    let letter = _letter.toLowerCase();
    let texture = null;

    this.cube.name = letter;
    this.cleanUpGroup();

    if (!this.all_textures[letter]) {
      const extraLetter = Letter3D.set(letter);
      extraLetter.name = letter;
      this.rotation.x = 0;
      this._fall = true;
      this._offset2 = -9;
      this.add(extraLetter);
      this.NO_TEXTURE = true;
    } else {
      this.setupDefaultRotations(isGameClue);
      this.add(this.cube);
    }

    if (this.all_textures[letter]) texture = this.all_textures[letter];
    else texture = this.all_textures["default"];

    this.cube.material[4].map =
      texture[Math.floor(Math.random() * texture.length)];
    this.cube.material[4].needsUpdate = true;
  }

  setSpecialCharacter(
    _letter,
    size = 30,
    height = 3,
    rotation = { x: 0, y: 0, z: 0 }
  ) {
    this._offset = -10;
    this._fall = false;
    this.rotation.x = 0;
    this._initialRotation = 0;
    this.rotation.z = 0;
    this.cleanUpGroup();
    let letter = _letter.toLowerCase();
    const extraLetter = Letter3D.set(letter, size, height);
    extraLetter.name = letter;
    this.rotation.x = rotation.x;
    this.rotation.y = rotation.y;
    this.rotation.z = rotation.z;
    this.add(extraLetter);
  }

  updateTexture(_letter) {
    let letter = _letter.toLowerCase();
    let texture = null;
    if (this.all_textures[letter]) texture = this.all_textures[letter];
    else texture = this.all_textures["default"];
    this.cube.material[4].map =
      texture[Math.floor(Math.random() * texture.length)];
    this.cube.material[4].needsUpdate = true;
    this.cube.name = _letter;
  }

  fillUpWithSingleColor() {
    const texture = this.all_textures["default"];
    this.cube.material[4].map =
      texture[Math.floor(Math.random() * texture.length)];
    this.cube.material[4].needsUpdate = true;
  }

  setfullColor(color) {
    // get first child texture
    this.children[0].material.color.setHex(color);
  }

  // animations stuff
  jump() {
    // play random sound
    AudioEffects.playRandom(120);

    const _z = this.position.z;
    new TWEEN.Tween(this.position)
      .to({ z: _z - 20 }, 500)
      .easing(TWEEN.Easing.Cubic.Out)
      .start();
    new TWEEN.Tween(this.position)
      .to({ y: this._offset }, 700)
      .easing(TWEEN.Easing.Elastic.Out)
      .start();

    // check if has to fall
    if (this._fall) {
      setTimeout(() => {
        this.fall();
      }, 200);
    }
  }

  fall() {
    setTimeout(() => {
      AudioEffects.play("falling");
      // AudioEffects.falling.currentTime = 0;
      // AudioEffects.falling.play();
      // AudioEffects.playRandom(120);
    }, 10);
    new TWEEN.Tween(this.rotation)
      .to({ x: -Math.PI / 2 }, 900)
      .easing(TWEEN.Easing.Bounce.Out)
      .start();
    new TWEEN.Tween(this.position)
      .to({ y: this._offset2 }, 900)
      .easing(TWEEN.Easing.Bounce.Out)
      .start();
  }

  hide() {
    const _x = this.position.x;
    new TWEEN.Tween(this.position)
      .to({ y: -31 }, 200)
      .easing(TWEEN.Easing.Cubic.In)
      .onComplete(() => {
        this.position.z = this.origineZ;
        if (this._fall) this.rotation.x = 0;
        this.cleanUpGroup();
      })
      .start();
  }

  roll() {
    // play random sound
    AudioEffects.playRandomProgress(120);

    const goal = Math.PI * 2;
    // const originalRotation = letter.rotation;
    new TWEEN.Tween(this.cube.rotation)
      .to({ x: goal }, 2000)
      .easing(TWEEN.Easing.Elastic.Out)
      .onComplete(() => {
        this.cube.rotation.x = 0;
      })
      .start();
  }

  pop() {
    AudioEffects.play("error");
    // AudioEffects.error.currentTime = 0;
    // AudioEffects.error.play();
    // for error interface
    const goal = -Math.PI / 2;
    new TWEEN.Tween(this.rotation)
      .to({ x: goal }, 500)
      .easing(TWEEN.Easing.Bounce.Out)
      .onComplete(() => {
        this.rotation.x = -Math.PI / 2;
      })
      .start();
  }

  excite() {
    if (this.cube.name == " " || this.cube.name == "") return;
    // this.position.y = this._offset + 20;
    const t1 = new TWEEN.Tween(this.position)
      .to({ y: this._offset + 20 }, 100)
      .easing(TWEEN.Easing.Exponential.Out);
    const t2 = new TWEEN.Tween(this.position)
      .to({ y: this._fall ? this._offset2 : this._offset }, 600)
      .easing(TWEEN.Easing.Bounce.Out);

    t1.chain(t2).start();
  }

  kill() {
    // this.position.y = this._offset + 20;
    const t1 = new TWEEN.Tween(this.position)
      .to({ y: this._offset + 20 }, 100)
      .easing(TWEEN.Easing.Exponential.Out);
    const t2 = new TWEEN.Tween(this.position)
      .to({ y: -40 }, 600)
      .easing(TWEEN.Easing.Bounce.Out);

    t1.chain(t2).start();
  }
}
